import { useEffect, useState } from 'react';
import { useLocation } from 'react-use';
import { getBridge } from 'leo-manager/utils/bridge';

export interface OnlineMeasurementSettings {
  currentRoom: number | null;
  isOnlineMeasurementsDisabled: boolean;
}

const defaultSettings = {
  currentRoom: null,
  isOnlineMeasurementsDisabled: false,
};

export const useOnlineMeasurementSettings = (): OnlineMeasurementSettings => {
  const [settings, setSettings] =
    useState<OnlineMeasurementSettings>(defaultSettings);
  const location = useLocation();

  useEffect(() => {
    const bridge = getBridge();
    bridge?.getWorkstationSettings()?.then((data) => {
      setSettings({
        currentRoom: data?.isMapWorkstationToRoomEnabled ? data?.roomId : null,
        isOnlineMeasurementsDisabled:
          data?.isMapWorkstationToRoomEnabled &&
          data?.isOnlineMeasurementsDisabled,
      });
    });
  }, [location]);

  return settings;
};
